import { Directive, ElementRef, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Directive({
  selector: '[dbInAnswerSetRoute]'
})

export class InAnswerSetRouteDirective implements OnInit {

  constructor(
    private activatedRoute: ActivatedRoute,
    private elementRef: ElementRef
  ) { }

  ngOnInit() {
    this.checkIfInAnswerSetRoute();
  }

  checkIfInAnswerSetRoute() {
    const answerSetRoutePath = this.activatedRoute.snapshot.url[0].path;
    if (answerSetRoutePath === 'answer-set') {
      this.elementRef.nativeElement.parentElement.removeChild(this.elementRef.nativeElement);
    }
    return;
  }
}
